<template>
    <div class="index">
        <van-nav-bar title="充值记录" fixed placeholder left-arrow @click-left="onClickLeft" />
        <div class="content">
            <van-tabs
                v-model="status"
                @click="onClickStatus"
                background="transparent"
                type="card"
                color="#245DC4"
                style="margin-bottom: var(--base-px-10)"
            >
                <van-tab title="待审核"></van-tab>
                <van-tab title="审核通过"></van-tab>
                <van-tab title="审核拒绝"></van-tab>
            </van-tabs>
            <List
                v-model="loading"
                :finished="finished"
                :error="loadError"
                :error-text="loadErrorText"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <div
                    v-for="item in list"
                    :key="item.id || item.app_no"
                    class="recharge-card"
                >
                    <div class="recharge-header">
                        <div class="tenant-info">
                            <div class="tenant-name">
                                {{ item.tenant_name }}
                            </div>
                            <div class="recharge-no">
                                充值单ID：{{ item.id }}
                            </div>
                        </div>
                        <div
                            class="recharge-status"
                            :class="`status-${
                                item.status_text === '待审核'
                                    ? 'wait'
                                    : item.status_text === '审核通过'
                                    ? 'success'
                                    : 'fail'
                            }`"
                        >
                            {{ item.status_text }}
                        </div>
                    </div>

                    <div class="recharge-details">
                        <div class="detail-item">
                            <span class="detail-label">经销商名称：</span>
                            <span class="detail-value">{{
                                item.tenant_name
                            }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">充值金额：</span>
                            <span class="detail-value">¥{{ item.money }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">实际到账：</span>
                            <span class="detail-value"
                                >¥{{ item.credit_money }}</span
                            >
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">费率：</span>
                            <span class="detail-value"
                                >{{
                                    parseFloat(item.recharge_rates) * 100
                                }}%</span
                            >
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">充值凭证：</span>
                            <van-image
                                class="recharge-voucher"
                                :src="item.recharge_img_url_text"
                                alt="充值凭证"
                                @click="
                                    showImagePreviewItem(
                                        item.recharge_img_url_text
                                    )
                                "
                            />
                        </div>
                        <div v-if="item.remake" class="detail-item">
                            <span class="detail-label">审核备注：</span>
                            <span class="detail-value remake">{{
                                item.remake
                            }}</span>
                        </div>
                    </div>
                </div>
            </List>
            <van-image-preview
                v-model:show="showPreview"
                :images="previewImageUrl"
            >
            </van-image-preview>
        </div>
    </div>
</template>

<script>
import { List } from "vant";
import { trafficRechargeList } from "../../api/traffic";

export default {
    name: "rechargeList",
    components: {
        List,
    },
    data() {
        return {
            pages: 1,
            page_size: 10,
            status: 1, // 默认为待审核状态
            list: [],
            finished: false,
            loading: false,
            loadError: false,
            loadErrorText: "",
            showPreview: false,
            previewImageUrl: [],
            status: 0,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        onClickLeft() {
            this.$router.back();
        },
        onClickStatus(index) {
            console.log(index);
            this.status = Number(index);
            this.pages = 1;
            this.list = [];
            this.finished = false;
            this.loading = false;
            this.loadError = false;
            this.loadErrorText = "";
            this.getList();
        },
        onLoad() {
            this.pages++;
            this.getList();
        },
        getList() {
            this.loading = true;

            // 调用充值记录列表接口
            trafficRechargeList({
                page: this.pages,
                status: this.status + 1,
            })
                .then((res) => {
                    if (res.code == 1) {
                        if (res.data.count <= this.pages * 10) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }

                        // 添加新数据到列表
                        this.list = [...this.list, ...res.data.list];

                        this.loadError = false;
                        this.loadErrorText = "";
                    } else {
                        this.$toast.fail(res.msg);
                        this.loadError = true;
                        this.loadErrorText = res.msg;
                    }

                    this.loading = false;
                })
                .catch((err) => {
                    this.$toast.fail("数据加载失败，请稍后重试");
                    this.loadError = true;
                    this.loadErrorText = "数据加载失败，请稍后重试";
                    this.loading = false;
                });
        },
        // 预览图片
        showImagePreviewItem(url) {
            if (url) {
                this.previewImageUrl = [url];
                this.showPreview = true;
            }
        },
    },
};
</script>

<style scoped lang="less">
.index {
    background: #f5f5f5;
    min-height: 100vh;
}
.content{
    padding: var(--base-px-12);
}
.recharge-card {
    background: #ffffff;
    border-radius: var(--base-px-8);
    margin-bottom: var(--base-px-12);
    padding: var(--base-px-16);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.recharge-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: var(--base-px-12);
}

.tenant-info {
    flex: 1;
}

.tenant-name {
    font-size: var(--base-px-16);
    font-weight: 500;
    color: #333333;
    margin-bottom: var(--base-px-4);
}

.recharge-no {
    font-size: var(--base-px-12);
    color: #999999;
}

.recharge-status {
    padding: var(--base-px-4) var(--base-px-8);
    border-radius: var(--base-px-4);
    font-size: var(--base-px-12);
    font-weight: 500;

    &.status-wait {
        background-color: #fff3cd;
        color: #856404;
    }

    &.status-success {
        background-color: #d4edda;
        color: #155724;
    }

    &.status-fail {
        background-color: #f8d7da;
        color: #721c24;
    }
}

.recharge-details {
    display: flex;
    flex-direction: column;
    gap: var(--base-px-10);
}

.detail-item {
    font-size: var(--base-px-14);
    color: #666666;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
    }
}

.detail-label {
    color: #999999;
    min-width: var(--base-px-80);
    margin-right: var(--base-px-8);
    flex-shrink: 0;
    align-self: center;
}

.detail-value {
    color: #333333;
    flex: 1;

    &.remake {
        background-color: #f8f9fa;
        padding: var(--base-px-8);
        border-radius: var(--base-px-4);
        word-break: break-all;
    }
}

.recharge-voucher {
    width: var(--base-px-80);
    height: var(--base-px-80);
    border-radius: var(--base-px-4);
    cursor: pointer;
    object-fit: cover;
    margin-top: var(--base-px-4);
    border: var(--base-px-1) solid #eee;
}
</style>
